import { encodeObject, GETAll } from "./GET";

const makeRedirectURL = (basePath, params = GETAll()) => {
	const glue = basePath.indexOf("?") === -1 ? "?" : "&";
	return `${basePath}${glue}${encodeObject(params)}`;
};

export default makeRedirectURL;
